export const AUTH_LOGOUT_PATH = '/auth/logout'
